<div class="admin-container">
  <form class="form">
    <div class="input-group">
      <label>Paragraphe</label>
      <app-text-editor
        [(ngModel)]="sectionData.text"
        [name]="sectionData.id + 'text'"
      ></app-text-editor>
    </div>
  </form>
</div>
